import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <Circle cx={12} cy={12} r={12} fill="#000" fillOpacity={0.1} />
      <Path
        d="M12.916 12l3.894-3.894a.647.647 0 10-.916-.916L12 11.084 8.106 7.19a.647.647 0 10-.916.916L11.084 12 7.19 15.894a.647.647 0 10.916.916L12 12.916l3.894 3.894a.646.646 0 00.916 0 .647.647 0 000-.916L12.916 12z"
        fill="#000"
        fillOpacity={0.7}
      />
    </Svg>
  );
}

export default SvgComponent;
